<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="title">
        <span>活动信息</span>
      </div>
      <div class="detail-info">
        <div class="detail-item">
          <div class="item-name">主题名称</div>
          <div class="item-value">{{detailInfo.themeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">渠道</div>
          <div class="item-value">{{detailInfo.channelName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动名称</div>
          <div class="item-value">{{detailInfo.privateThemeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">所属区域</div>
          <div class="item-value">{{detailInfo.orgName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">已选Area</div>
          <div class="item-value">
            <span style="margin-right:20px;padding-bottom:9px" v-for="item in areaList" :key="item.areaCode">{{item.orgName}}</span>
          </div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动时间</div>
          <div class="item-value">{{detailInfo.startDate | parseTime('{y}-{m}-{d}')}}至{{detailInfo.endDate | parseTime('{y}-{m}-{d}')}}</div>
        </div>
        <!-- <div class="detail-item">
          <div class="item-name">执行周数</div>
          <div class="item-value" v-if="detailInfo.execWeekChooseType === '01'">{{detailInfo.execWeekMin + '-' + detailInfo.execWeekMax}}</div>
          <div class="item-value" v-if="detailInfo.execWeekChooseType === '02'">{{detailInfo.execWeekScope}}</div>
        </div>-->
        <div class="detail-item">
          <div class="item-name">最少执行时间（天）</div>
          <div class="item-value">{{detailInfo.execDaysMin}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">打卡频次（天/次）</div>
          <div class="item-value">{{detailInfo.execDaysCycle}}</div>
        </div>
        <div class="detail-item-nowrap">
          <div class="item-name">陈列追踪方式</div>
          <div class="item-value">{{detailInfo.trackTypeNameScope}}</div>
        </div>
        <div class="detail-item-nowrap">
          <div class="item-name">费用返还方式</div>
          <div class="item-value">{{detailInfo.bonusTypeNameScope}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">入账品牌</div>
          <div class="item-value">{{detailInfo.entryBrandCodeName}}</div>
        </div>
        <div class="detail-item" v-if="detailInfo.tradeBudgetTypeDTO">
          <div class="item-name">预算池</div>
          <div
            class="item-value"
          >{{`${detailInfo.tradeBudgetTypeDTO.typeName} (${detailInfo.tradeBudgetTypeDTO.trCodeName}) - 可用预算：`}}{{detailInfo.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
        </div>
      </div>
      <!-- 先蜂购线上免费酒设置 -->
      <div class="detail-info" v-if="detailInfo.bonusTypeScope && detailInfo.bonusTypeScope.indexOf('04') !== -1">
        <div class="detail-item-bonus bonus">
          <div class="bonus-title">先蜂购线上免费酒返还设置 <span style="color:#c8102d;font-weight:400;margin-left:20px">（当前修改只影响后续打卡产生的免费酒类型和数量）</span></div>
          <div class="bonus-content">
            <RegionBeesBonusBeer ref="BonusBeerOnline" :monthList="monthList" :dataList="tradePerfectBonusBeerGroupList" type="change" :themeStatus="detailInfo.themeStatus"></RegionBeesBonusBeer>
            <div class="coupon-bonus-beer" style="width:100%">
              <div style="width:17%">
                <i>*</i> 赠酒券有效时间
              </div>
              <div style="width:70%" v-if="false">
                <div>
                  <el-radio v-model="beesCouponAssignRule.type" label="01">&nbsp;</el-radio>发券后
                  <el-input-number v-model="beesCouponAssignRule.validDays" :min="0" :precision="0" style="margin:0 5px" placeholder="请输入"></el-input-number>天内
                </div>
                <div>
                  <el-radio v-model="beesCouponAssignRule.type" label="02">&nbsp;</el-radio>永久有效
                </div>
              </div>
              <div v-else>
                <div v-if="beesCouponAssignRule.type === '01'">发券后 {{beesCouponAssignRule.validDays}} 天内</div>
                <div v-if="beesCouponAssignRule.type === '02'">永久有效</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class style="border-radius: 10px;overflow:hidden" v-if="detailInfo.taskTypeScope && detailInfo.taskTypeScope.indexOf('05') !== -1">
        <RegionStr ref="regionStr" :strTaskList="strTaskInfo.saleScopeList" :monthList="monthList" type="change" :themeStatus="detailInfo.themeStatus"></RegionStr>
      </div>
          <div class="handle-foot">
      <el-button class="btn-red"  :loading="btnLoading" @click="check(0)">保存</el-button>
      <el-button class="btn-red"  :loading="btnLoading" @click="check(1)">提交</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import moment from 'moment'
import ContentHeader from '@/components/content-header'
import RegionBeesBonusBeer from '@/views/trade/perfect2022/components/region-bees-bonus-beer.vue'
import RegionStr from '@/views/trade/perfect2022/components/region-str.vue'
export default {
  components: {
    ContentHeader,
    RegionBeesBonusBeer,
    RegionStr
  },
  data () {
    return {
      loading: false,
      btnLoading: false,
      detailInfo: {},
      strTaskInfo: {},
      areaList: [],
      tradePerfectBonusBeerGroupList: [],
      monthList: [],
      params: {
        themeDefineId: '',
        bonusTypeScope: '',
        taskTypeScope: '',
        saveFlag: '',
        tradePerfectBonusBeerGroupList: [],
        tradePerfectTaskDefineList: []
      }
    }
  },
  computed: {
    beesCouponAssignRule () {
      let obj = {}
      if (this.detailInfo.beesCouponAssignRule) {
        obj = JSON.parse(this.detailInfo.beesCouponAssignRule)
      }
      return obj
    }
  },
  created () {
    this.getDetailInfo()
  },
  methods: {
    // 获取活动详情
    getDetailInfo () {
      this.loading = true
      tradeApi.getBuPerfectTasksConfigInfo({ themeDefineId: this.$route.query.themeDefineId }).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.detailInfo = res.data.resultData.tradePerfectThemeDefineDTO
          this.history = res.data.resultData.tradePerfectThemeDefineDTO.commonProcessRecordDTOList
          this.getTask()
          this.getAreaList()
          this.getReportCycle()
          if (this.detailInfo.bonusTypeScope.indexOf('04') !== -1) {
            this.tradePerfectBonusBeerGroupList = this.detailInfo.tradePerfectBonusBeerGroupList
          }
        }
      })
    },
    // 获取已选择任务
    getTask () {
      this.detailInfo.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '05') {
          this.strTaskInfo = item
        }
      })
    },
    // 获取areaList
    getAreaList () {
      tradeApi.getAreaList({ regionCode: this.detailInfo.orgCode }).then(res => {
        if (res.data.resultCode === '0') {
          let list = res.data.resultData.regionList
          if (this.detailInfo.areaCodes && this.detailInfo.areaCodes.length) {
            this.areaList = this.detailInfo.areaCodes.split(',').map(item => {
              for (let i = 0; i < list.length; i++) {
                if (list[i].orgCode === item) {
                  return list[i]
                }
              }
            })
          } else {
            this.areaList = list
          }
        }
      })
    },
    // 计算月份信息
    getReportCycle () {
      if (!this.detailInfo.startDate || !this.detailInfo.endDate) {
        return
      }
      let startDate = moment(moment(this.detailInfo.startDate).startOf('month').format('YYYY-MM-DD'))
      let endDate = moment(moment(this.detailInfo.endDate).endOf('month').format('YYYY-MM-DD'))
      let startYear = startDate.format('YYYY')
      let startMonth = startDate.format('M')
      let list = []
      for (let i = startMonth; i < endDate.diff(startDate, 'months') + 1 + parseInt(startMonth); i++) {
        let month = (i % 12) === 0 ? 12 : (i % 12)
        let num = i % 12 === 0 ? Math.floor(i / 12) - 1 : Math.floor(i / 12)
        let year = parseInt(startYear) + num
        let obj = {
          year,
          month: month > 9 ? month + '' : '0' + month
        }
        list.push(obj)
      }
      this.monthList = list
    },
    // str任务十五号限制
    checkChangeDate (date) {
      let nowDate = new Date().getTime()
      let bonusDate = new Date(date.year + '/' + date.month + '/16').getTime()
      // 禁止修改
      if (nowDate > bonusDate) {
        return true
      }
      // 允许修改
      return false
    },
    // 判断先蜂购奖励酒是否在当月
    checkBeesBonusDate (date) {
      let nowDate = new Date().getTime()
      let year = new Date(date.year.toString()).getFullYear()
      let month = new Date(date.month.toString()).getMonth() + 1
      let newMonth = ++month
      if (newMonth === 13) {
        year++
        month = 1
      }
      // 下月第一天
      let lastDay = new Date(`${year}/${month}`).getTime()
      // 禁止修改
      if (nowDate >= lastDay) {
        return true
      }
      // 允许修改
      return false
    },
    // 先蜂购线上免费酒
    setBeesBonusBeer () {
      let list = this.$refs.BonusBeerOnline.getValue()
      let groupNameList = []
      // let skuInfoList = []
      let groupInfoList = []
      for (let i = 0; i < list.length; i++) {
        if (!list[i].groupName) {
          this.$message.warning(`请填写先蜂购线上免费酒返还，奖励组合${i + 1} 组合名称`)
          return false
        }
        if (groupNameList.includes(list[i].groupName)) {
          this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1} 组合名称重复，请修改后提交`)
          return false
        }
        groupNameList.push(list[i].groupName)
        let skuCodeList = []
        let monthNum = {}
        for (let j = 0; j < list[i].bonusDetail.length; j++) {
          if (!list[i].bonusDetail[j].skuCode) {
            this.$message.warning(`请选择先蜂购线上免费酒返还，奖励组合${i + 1} 赠酒SKU`)
            return false
          }
          // 同一组合内有重复SKU
          if (skuCodeList.includes(list[i].bonusDetail[j].skuCode)) {
            this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1} SKU重复，请修改后提交`)
            return false
          }
          // 不同组合内有重复SKU
          // if (skuInfoList.find(item => item.skuCode === list[i].bonusDetail[j].skuCode)) {
          //   let repeatSkuInfo = skuInfoList.find(item => item.skuCode === list[i].bonusDetail[j].skuCode)
          //   let canReturn = false
          //   for (let repeatIndex = 0; repeatIndex < repeatSkuInfo.values.length; repeatIndex++) {
          //     for (let skuIndex = 0; skuIndex < list[i].bonusDetail[j].values.length; skuIndex++) {
          //       // 相同sku 每月赠酒数有不同
          //       if (repeatSkuInfo.values[repeatIndex].month === list[i].bonusDetail[j].values[skuIndex].month && repeatSkuInfo.values[repeatIndex].value !== list[i].bonusDetail[j].values[skuIndex].value) {
          //         canReturn = true
          //       }
          //     }
          //   }
          //   if (!canReturn) {
          //     this.$message.warning(`先蜂购线上免费酒返还，SKU ${repeatSkuInfo.skuName} 重复，请修改后提交`)
          //     return false
          //   }
          // }

          // 每月赠酒数是否未填写
          for (let numIndex = 0; numIndex < list[i].bonusDetail[j].values.length; numIndex++) {
            let num = list[i].bonusDetail[j].values[numIndex]
            if (!num.value && num.value !== 0) {
              this.$message.warning(`请填写先蜂购线上免费酒返还，奖励组合${i + 1} SKU:${list[i].bonusDetail[j].skuName} ${num.month}返还数量`)
              return false
            }
          }

          // 单月奖励总和是否为0
          for (let numIndex = 0; numIndex < list[i].bonusDetail[j].values.length; numIndex++) {
            let num = list[i].bonusDetail[j].values[numIndex]
            monthNum[num.month] = monthNum[num.month] ? monthNum[num.month] : 0
            monthNum[num.month] += num.value
          }
          skuCodeList.push(list[i].bonusDetail[j].skuCode)
          // skuInfoList.push(list[i].bonusDetail[j])
        }

        // 奖励组合重复
        let sortList = JSON.parse(JSON.stringify(list[i].bonusDetail)).map(item => {
          delete item.isActiveUUID
          return item
        }).sort((a, b) => {
          return a.skuCode - b.skuCode
        })
        let isRepeat = groupInfoList.findIndex(item => {
          return item === JSON.stringify(sortList)
        })
        if (isRepeat !== -1) {
          this.$message.warning(`先蜂购线上免费酒返还，奖励组合${isRepeat + 1}与奖励组合${i + 1} 重复，请修改后提交`)
          return false
        }
        groupInfoList.push(JSON.stringify(sortList))

        // 单月奖励总和是否为0
        for (const month in monthNum) {
          let date = {
            year: month.slice(0, 4),
            month: month.slice(5, 7)
          }
          if (this.checkBeesBonusDate(date)) {
            continue
          }
          if (monthNum[month] === 0) {
            this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1}: ${date.year}年${date.month}月单月奖励总和不能为0`)
            return false
          }
        }
      }

      if (this.beesCouponAssignRule.type === '01' && !this.beesCouponAssignRule.validDays) {
        this.$message.warning('请填写先蜂购线上免费酒返还，赠酒券有效时间')
        return false
      }
      list = JSON.parse(JSON.stringify(list))
      for (let i = 0; i < list.length; i++) {
        list[i].bonusDetail = JSON.stringify(list[i].bonusDetail)
      }
      this.params.tradePerfectBonusBeerGroupList = []
      this.params.tradePerfectBonusBeerGroupList = list
      return true
    },
    setStrTask () {
      this.params.tradePerfectTaskDefineList = []
      let list = this.$refs.regionStr.setValue()
      if (!list) {
        return false
      } else if (list !== true) {
        this.params.tradePerfectTaskDefineList.push({
          taskType: '05',
          taskName: 'STR',
          taskDefineId: this.strTaskInfo.taskDefineId,
          saleScopeList: list,
          scopeDefineId: this.strTaskInfo.scopeDefineId
        })
      }
      return true
    },
    // 提交修改
    check (mode) {
      if (this.detailInfo.bonusTypeScope.indexOf('04') !== -1) {
        if (!this.setBeesBonusBeer()) {
          return
        }
        this.params.bonusTypeScope = '04'
      }

      if (this.detailInfo.taskTypeScope.indexOf('05') !== -1) {
        if (!this.setStrTask()) {
          return
        }
        this.params.taskTypeScope = '05'
      }

      this.params.themeDefineId = this.detailInfo.themeDefineId
      this.params.saveFlag = mode
      let message = ''
      let successMessage = ''
      if (mode === 0) {
        message = '请输入保存备注'
        successMessage = '已成功保存，若需生效请提交审批'
      } else {
        message = '请输入提交备注'
        successMessage = '已成功提交，BU TM审批后生效'
      }
      this.$prompt(`${message}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.params.processRemark = value
        this.handleSubmit(successMessage)
      }).catch(() => {
      })
    },
    handleSubmit (msg) {
      this.btnLoading = true
      tradeApi.handleUpdateBonusStr(this.params).then(res => {
        this.btnLoading = false
        if (res.data.resultCode === '0') {
          this.$alert(`${msg}`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.go(-1)
            }
          })
        }
      }).catch(() => {
        this.btnLoading = false
      })
    }

  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #cd1231;
  border-color: #cd1231;
  font-weight: 400;
}
::v-deep .el-step__head.is-success,
::v-deep .el-step__head.is-process {
  font-size: 14px;
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
  display: none;
}
::v-deep .el-input-number .el-input__inner {
  padding: 0;
}
.el-input-number {
  width: 80px;
  &::v-deep .el-input__inner {
    padding: 0;
  }
}
::v-deep .el-input .el-input__inner {
  height: 30px;
}
// .el-button {
//   width: 50px;
//   height: 30px;
//   padding: 0;
// }
.content-container {
  width: 1200px;
  .steps {
    padding: 25px 100px;
    background-color: #fff;
    border-radius: 10px;
  }
  .steps-disable {
    background-color: #fff;
    color: #cd1231;
    text-align: center;
    padding: 50px 0;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      font-weight: 700;
      line-height: 60px;
      padding-left: 10px;
    }
  }
  .detail-info {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    .detail-item {
      width: 50%;
      display: flex;
      flex-wrap: wrap;
      .item-name {
        // width: 130px;
        height: 48px;
        // flex-basis: 25%;
        width: 145px;
        padding-left: 10px;
      }
      .item-value {
        width: 406px;
        // flex-basis: 70%;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .detail-item-nowrap {
      display: flex;
      flex-wrap: wrap;
      flex-basis: 100%;
      .item-name {
        width: 145px;
        height: 48px;
        padding-left: 10px;
      }
      .item-value {
        // flex-basis: 88%;
        flex: 1;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .detail-item-bonus {
      width: 100%;
      background-color: #f8f8f8;
      margin-bottom: 20px;
      border-radius: 6px;
      padding: 20px 10px 0;
      .item-name {
        // width: 145px;
        height: 48px;
        font-weight: 700;
      }
      .item-value {
        & > div {
          width: 100%;
          display: flex;
        }
        .bonus-name {
          width: 145px;
          height: 48px;
        }
        .bonus-value {
          flex: 1;
        }
      }
    }
  }
}
.bonus {
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 0px 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  // line-height: 40px;
  .bonus-title {
    font-size: 14px;
    font-weight: 700;
    // padding-left: 20px;
    box-sizing: border-box;
  }
  .bonus-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    i {
      color: #c8102d;
      font-size: 16px;
      font-weight: 700;
      margin-right: 10px;
    }
    .el-radio {
      margin-right: 10px;
    }
    .el-radio ::v-deep .el-radio__input {
      display: inline-block;
    }
    .el-radio ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #606266;
    }
    .coupon-bonus-beer {
      display: flex;
      line-height: 40px;
      margin: 20px 0 10px;
    }
  }
}
.handle-foot {
  width: 300px;
  margin: 40px auto 40px;
  display: flex;
  justify-content: space-around;
}
</style>
